import React from 'react';

interface PageContainerProps {
  children: React.ReactNode;
  className?: string;
  fluid?: boolean;
  padding?: string;
  pageType?: 'default' | 'background-image' | 'admin';
}

/**
 * 共通ページコンテナコンポーネント
 * 各ページで共通のレイアウト構造を提供
 * 
 * @deprecated 新しいページではPageWrapperの使用を推奨
 * PageWrapperはタイトル管理も含む統合コンポーネントです
 */
const PageContainer: React.FC<PageContainerProps> = ({ 
  children, 
  className = '', 
  fluid = true,
  padding = 'p-5',
  pageType = 'default' 
}) => {
  const containerClass = fluid ? 'container-fluid' : 'container';
  
  // ページタイプに応じたパディング設定
  let finalPadding = padding;
  if (pageType === 'background-image') {
    finalPadding = 'p-0';
  } else if (pageType === 'admin') {
    finalPadding = 'p-5'; // 管理者ページも統一してp-5に
  } else if (pageType === 'default') {
    finalPadding = 'p-5'; // デフォルトはp-5
  }
  
  return (
    <div className={`${containerClass} ${finalPadding} ${className}`}>
      <div className="row">
        <div className="col-12">
          {children}
        </div>
      </div>
    </div>
  );
};

export default PageContainer; 